<template>
  <div class="login-form-outer">
    <form class="login-form" @submit.prevent="onSubmit"> <!-- data-request="onSignin" -->
      <div class="row row-2">
        <label for="userSigninLogin">Email</label>
        <input v-model="email" type="text" placeholder="Inserisci la tua email" name="email" id="userSigninLogin">
        <!-- <input name="login" type="text" class="form-control" id="userSigninLogin" placeholder="Inserisci la tua email" ref="email"> -->
        
        <label for="userSigninPassword">Password</label>
        <input v-model="password" type="password" placeholder="Inserisci la tua password" name="password" id="userSigninPassword" />
        <!-- <input name="password" type="password" class="form-control" id="userSigninPassword" placeholder="Inserisci la tua password" ref="password"> -->
      </div>
      <!-- <input type="submit" class="button button-regular button-azure button-anim" value="ACCEDI" /> -->
      <button class="button button-regular button-azure button-anim">Accedi</button>

    </form>
    
    <router-link class="button button-regular button-azure button-anim" to="/signup">Registrati</router-link>
    <p class="recover"><span>Non ricordi più la tua password?</span> <router-link to="/recover">Clicca qui per recuperarla</router-link></p>

    <error-warning 
      :isError="showErrorWarning"
      @close="showErrorWarning = false"
      bgColor="aqua" 
      message="Spiacenti, non è stato possibile collegarsi.<br>Per favore, controlla di aver inserito la tua email e la password senza errori. In caso di nuova iscrizione verifica di aver cliccato sul link di verifica ricevuto via email."
      recoverPassword=true>
    </error-warning>
  </div>
</template>

<script>
import axios from 'axios/dist/axios';
import ErrorWarning from './ErrorWarning';

export default {
  data() {
    return {
      showErrorWarning: false,
      email: '',
      password: ''
    }
  },

  methods: {
    onSubmit: function(e) {
      const data = {
        email: this.email,
        password: this.password
        //email: this.$refs.email.value,
        //password: this.$refs.password.value
      };

      axios.post('/api/v1/user/login', data)
        .then(resp => {
          this.$eventBus.$emit('user:login', {user: resp.data.user, token: resp.data.token});
        })
        .catch(err => {
          this.showErrorWarning = true;
        });
    },

    closeWarning: function(e) {
      this.showErrorWarning = false;
    }
  },

  components: {
    'error-warning': ErrorWarning
  }
}
</script>

<style>
  p.recover {
    padding-top: 1.5em;
    font-size: 14px !important;
    line-height: 1.2 !important;
  }
</style>



// WEBPACK FOOTER //
// src/vue/components/LoginForm.vue